// eslint-disable-next-line import-x/no-extraneous-dependencies
import { endOfMonth, endOfWeek, startOfMonth, startOfWeek } from '@internationalized/date';
import { isSameDay } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { TFunction } from 'i18next';

import { ScheduleDailyOverview, ScheduleElement } from '../../../graphql/components';
import { getCalculatedHoursMinutes } from '../../../utils/date';

import type { CalendarDate } from '@internationalized/date';

export const getScheduleItemByDate = (date: Date, scheduleItems: ScheduleDailyOverview[], timezone: string) =>
  scheduleItems.find((item) =>
    isSameDay(zonedTimeToUtc(date, timezone), zonedTimeToUtc(new Date(item.date), timezone))
  );

export const getScheduleElement = (id: string, scheduleElements: ScheduleElement[]) =>
  scheduleElements.find((element) => element.id === id);

export const formatShiftDuration = (totalHours: number, t: TFunction) => {
  const { hours, minutes } = getCalculatedHoursMinutes(totalHours);

  const hoursTitle = t('time.hrs');
  const minutesTitle = t('time.min');

  const formattedTime: string[] = [];

  if (hours) {
    formattedTime.push(`${hours} ${hoursTitle}`);
  }

  if (minutes) {
    formattedTime.push(`${minutes} ${minutesTitle}`);
  }

  return formattedTime.join(' ');
};

export const hasDaySchedule = (scheduleItem?: ScheduleDailyOverview) =>
  scheduleItem &&
  (!!scheduleItem.shift ||
    scheduleItem.beforeShiftScheduleElementIds.length > 0 ||
    scheduleItem.overviewScheduleElementIds.length > 0);

export const getMonthlyRangeEnd = (selectedDate: CalendarDate, locale: string) =>
  endOfWeek(endOfMonth(selectedDate), locale).add({ days: 1 });

export const getMonthlyStatsRangeEnd = (selectedDate: CalendarDate) => endOfMonth(selectedDate).add({ days: 1 });

export const getMonthlyRangeStart = (selectedDate: CalendarDate, locale: string) =>
  startOfWeek(startOfMonth(selectedDate), locale);
